export class PendingQueue {
  private _tasks: (() => void)[] = [];

  constructor() {
    if (__BUILD_TARGET__ === 'client') {
      setInterval(this._doInterval, 20);
    }
  }

  public push(task: (...args: unknown[]) => void) {
    this._tasks.push(task);
  }

  private _doInterval = (): void => {
    if (this._tasks.length) {
      console.log('pending tasks found, total count: %d', this._tasks.length);
      this._tasks.forEach((task) => task());
      this._tasks = [];
    }
  };
}

export const pendingQueue = new PendingQueue();
